"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PonziSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const react_router_dom_1 = require("react-router-dom");
const react_intl_1 = require("react-intl");
const constants_1 = require("@dzambalaorg/constants");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const types_1 = require("../../../types");
const data = [
    { text: "pages.ponzi.contracts.title", link: "/ponzi/contracts", icon: (0, jsx_runtime_1.jsx)(icons_material_1.Collections, {}) },
    { text: "pages.ponzi.rules.title", link: "/ponzi/rules", icon: (0, jsx_runtime_1.jsx)(icons_material_1.Rule, {}) },
    { text: "pages.ponzi.report.title", link: "/ponzi/report", icon: (0, jsx_runtime_1.jsx)(icons_material_1.BarChart, {}) },
    { text: "pages.ponzi.chart.title", link: "/ponzi/chart", icon: (0, jsx_runtime_1.jsx)(icons_material_1.Timeline, {}) },
];
const PonziSection = ({ service }) => {
    const isProd = process.env.NODE_ENV === constants_1.NodeEnv.production;
    if (service === types_1.ServiceType.ADMIN && isProd) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Paper, { sx: { mb: 2 }, children: (0, jsx_runtime_1.jsx)(ui_kit_1.List, { component: "nav", subheader: (0, jsx_runtime_1.jsx)(ui_kit_1.List.Subheader, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "pages.dashboard.mechanics.ponzi" }) }), children: data.map(({ text, icon, link }) => ((0, jsx_runtime_1.jsxs)(ui_kit_1.List.ItemButton, { component: react_router_dom_1.Link, to: link, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemIcon, { children: icon }), (0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: text }) })] }, text))) }) }));
};
exports.PonziSection = PonziSection;
//# sourceMappingURL=ponzi.js.map